export function hasLocationContent(signals: {
    hasMap: boolean;
    hasScreening: boolean;
    hasPlanner: boolean;
    transportCount: number;
    canAskKits: boolean;
}): boolean {
    return (
        signals.hasMap ||
        signals.hasScreening ||
        signals.hasPlanner ||
        signals.transportCount > 0 ||
        signals.canAskKits
    );
}
